// extracted by mini-css-extract-plugin
export default {"invalid-error":"CorporationForm_invalid-error__QFPG7"};